<template>
	<div class="live-statistic_item">
		<div v-for="statistic in statistics" :key="statistic.name">
			<div class="live-statistic_row">
				<div class="live-statistic_text">
					<div v-if="statistic.name === 'Владение мячом'">{{ statistic.percentage.home }}%</div>
					<div v-else>{{ statistic.home }}</div>
				</div>
				<div class="live-statistic_text">
					{{ statistic.name }}
				</div>
				<div class="live-statistic_text">
					<div v-if="statistic.name === 'Владение мячом'">{{ statistic.percentage.away }}%</div>
					<div v-else>{{ statistic.away }}</div>
				</div>
			</div>
			
			<div class="live-statistic_row-2">
				<div class="live-statistic_col">
					<div class="live-statistic_line">
						<div class="live-statistic_line-inner" 
							 :class="getClassname(statistic.home, statistic.away)" 
							 :style="'width:' + statistic.percentage.home  + '%'"></div>
					</div>
				</div>
				<div class="live-statistic_col">
					<div class="live-statistic_line">
						<div class="live-statistic_line-inner __gray" 
							 :class="getClassname(statistic.away, statistic.home)"
							 :style="'width:' + statistic.percentage.away  + '%'"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data'],
		
		data() {
			return {
				
			}
		},
		
		computed: {
			statistics() {
				let array = [];
				
				for (let statistic in this.data) {
					var percentage = this.getPercentage(this.data[statistic].home, this.data[statistic].away);
					
					array.push({
						name: this.data[statistic].name,
						away: this.data[statistic].away,
						home: this.data[statistic].home,
						percentage: percentage
					});
					
				}
				
				return array;
			}
		},
		
		methods: {
			getPercentage(home, away) {
				var total = home + away;
				
				return {
					home: parseInt(home / total * 100) || 0,
					away: parseInt(away / total * 100) || 0
				}
			},
			getClassname(value1, value2) {
				return {
					'__green' : value1 > value2,
					'__gray' : value1 < value2 || value1 === value2
				};
			}
		},
		
		
		created() {
			
		}
	}
</script>

<style scoped>

</style>